<div class="mainBody">
    <app-header></app-header>
    <div class="flexBody d-flex">
        <div class="internalBodyOne">
            <app-sidebar [userDetails]="userDetails"></app-sidebar>
         </div>
         <div class="internalBodyTwo">
            <router-outlet></router-outlet>
        </div>
     </div>       
</div>
